// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollDownAction(80, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.getElementById('email-signup')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

    //CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
        }
	}

	document.querySelectorAll('.js-open-menu').forEach((open)=>{
		open.addEventListener('click',()=>{
			document.getElementById('menu-container').classList.add('show');
		})
	})

	document.querySelectorAll('.js-close-menu').forEach((close)=>{
		close.addEventListener('click',()=>{
			document.getElementById('menu-container').classList.remove('show');
		})
	})

	document.querySelectorAll('.btn:not(.reset), .btn-white, .btn-alt').forEach((button)=>{
		let span = document.createElement('span');
		button.insertAdjacentElement('afterbegin', span);
	});

	if(document.querySelector('.highlights')){
		let tabsItems = document.querySelectorAll('.highlights__tabs ul li');
		let imgItems = document.querySelectorAll('.highlights__image');
		tabsItems.forEach((tab)=>{
			tab.addEventListener('mouseenter', ()=>{
				let data = tab.dataset.img;
				tabsItems.forEach((tab2)=>{
					tab2.classList.remove('active');
				})
				imgItems.forEach((image)=>{
					image.classList.toggle('active', image.dataset.img == data);
				})
				tab.classList.add('active');
			})
		})
	}
	
	if(document.querySelector('.js-expand-form ')){
		document.querySelectorAll('.js-expand-form').forEach((button)=>{
			button.addEventListener('click', ()=>{
				let dataForm = button.dataset.form;
				button.classList.toggle('active');
				document.getElementById(dataForm).classList.toggle('hidden');
			})
		})
	}

	if(document.querySelector('.accordion')){
		document.querySelectorAll('.accordion').forEach((accordion) => {
			accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
				itemHead.addEventListener('click', (e) => {
					accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
						if (itemHead.parentNode !== item) item.classList.remove('open');
					});
					itemHead.parentNode.classList.toggle('open');
				});
			});
		});
		if(document.querySelector('.accordion__filter')){
			let tabsAccordion = document.querySelectorAll('.accordion__filter li');
			let itemsAccordion = document.querySelectorAll('.accordion__item');
			let lastTab = null;

			tabsAccordion.forEach((tab)=>{
				tab.addEventListener('click', ()=>{
					let data = tab.dataset.filter;
					if(lastTab){
						lastTab.classList.remove('active');
					}
					if(data == 'all'){
						itemsAccordion.forEach((item)=>{
							item.classList.remove('hidden');
						});
					}else{
						itemsAccordion.forEach((item)=>{
							item.classList.toggle('hidden', !item.dataset.tag.includes(data));
						});
					}
					tab.classList.add('active');
					lastTab = tab;
				})
			});
			tabsAccordion[0].click();
		}
	}

	if(document.getElementById('home')){
		let sliderQuad = document.querySelector('.slider-imgs');
		document.querySelector('.group-intro-content-home').insertAdjacentElement('beforeend', sliderQuad);
	}

	// WRAP MODULE TABLES
	if(document.querySelector('.form-module-wrapper')){
			document.querySelectorAll('.form-module-wrapper').forEach((text) => {
			text.querySelector('.form-module').classList.add('animate-fade','top');
		});
	}

	if(document.querySelector('.text-modules-wrapper')){
		document.querySelectorAll('.text-modules-wrapper').forEach((text) => {
		text.querySelector('.text-modules').classList.add('animate-fade','top');
	});
}

	if(document.querySelector('.global-sitemap')){
		document.querySelector('.global-sitemap').classList.add('animate-fade', 'top');
	}

	let scrollButtons = document.querySelectorAll('.js-scroll-form');

	if(scrollButtons.length > 0){
		scrollButtons.forEach((button)=>{
			button.addEventListener('click', (e)=>{
				e.preventDefault();
				let data = button.getAttribute('href').split('#')[1];
				let target = document.getElementById(data);
				let headerHeight = document.querySelector('header').offsetHeight + 250;

				window.scrollTo({
					top: target.offsetTop - headerHeight,
					behavior: 'smooth'
				});
				setTimeout(() => {
					document.querySelector('.js-expand-form').click();
				}, 1000);
			});
		});
	}
	
	var data = document.URL;
	if (data.indexOf("?data-form=") != -1) {
		data = data.split("?data-form=")[1];
		let target = document.getElementById(data);
		let headerHeight = document.querySelector('header').offsetHeight + 250;
		setTimeout(() => {
			window.scrollTo({
				top: target.offsetTop - headerHeight,
				behavior: 'smooth'
			});
			setTimeout(() => {
				document.querySelector('.js-expand-form').click();
			}, 500);
		}, 1000);
	}
})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
	const menu = document.querySelector('.menu-container');
	const isMenuVisible = menu && menu.classList.contains('show');
	const elements = document.querySelectorAll('.privary-navigation__item a, .menu-container__phone .phone');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}

document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('.menu-container');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});